import { Injectable } from '@angular/core';
import { BehaviorSubject, of, Observable } from 'rxjs'
import { distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';


interface State {
  data: any;
  authenticated: boolean;
}

const defaultState: State = {
  data: null,
  authenticated: Boolean(TokenStorageService)
};

const store = new BehaviorSubject<State>(defaultState);

class Store {
  private store = store;
  changes = this.store.asObservable().pipe(distinctUntilChanged());

  setState(state: State) {
    this.store.next(state);
  }

  getState(): State {
    return this.store.value;
  }

  updateState(data: State) {
    this.store.next({ ...this.getState(), ...data });
  }

  purge() {
    this.store.next(defaultState);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private store: Store = new Store();
  public authenticated: boolean = false;
  uname = '';
  public redirectUrl!: string;
  constructor(private http: HttpClient, private jwt: TokenStorageService, private router: Router) {
    this.store.setState({
      data: null, authenticated: Boolean(this.jwt.get())
    });
  }

  isAuthenticated(): Observable<any> {
    if (!this.jwt.get()) {
      return of(null);
    } else {
      return of(Boolean(this.jwt));
    }
  }

  attempAuth(uname: string, password: string): Observable<any> {
    this.uname = uname;
    return of(null)
  }

  b2cAttemptAuth(data: any): Observable<any> {
    this.jwt.save(data);
    this.authenticated = Boolean(data);
    return of(
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }

  // customertempAuth(data: any): Observable<any> {
  //   this.jwt.saveCT(data);
  //   this.authenticated = Boolean(data);
  //   return of(
  //     this.store.setState({
  //       data: data, authenticated: Boolean(data)
  //     })
  //   )
  // }

  //Method to store refresh token
  saveRefreshToken(data: any): Observable<any> {

    this.jwt.saveRT(data);

    return of(
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }

  refreshToken(): Observable<any> {
    const token = this.jwt.get();
    const refreshToken = this.jwt.getRT();
    const refreshTokenEndpoint = `${environment.baseAPIUrl}api/digital/core/Account/refreshToken`;
    return this.http.post<any>(refreshTokenEndpoint, { token, refreshToken });
  }
  getAuthState() {
    return this.store.getState();
  }

  logoutUser() {
    this.jwt.destroy();
    this.store.setState({
      data: null, authenticated: false
    });
    return of(
      this.store.setState({
        data: null, authenticated: false
      })
    )
  }
}
function jwt_decode(token: string) {
  throw new Error('Function not implemented.');
}

